document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".cust_wish-list").forEach(function (item) {
        item.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });
    // Niccos Product Grid
class ProductCardMedia extends HTMLElement {
  connectedCallback() {
    const container = this;

    const slider = container.querySelector(".cust-slider");
    const slides = container.querySelectorAll(".cust-slide");
    const prevBtn = container.querySelector(".cust-prev");
    const nextBtn = container.querySelector(".cust-next");
    const progressBar = container.querySelector(".cust-slider-progress-bar");

    if (!slider) return;

    let currentSlide = 0;
    let startX = 0;
    let startY = 0;
    let moveX = 0;
    let moveY = 0;
    let isDragging = false;
    let isHorizontalSwipe = false;
    const totalSlides = slides.length;

    const updateSlider = (index) => {
      currentSlide = index;
      const translateX = -(index * 100);
      slider.style.transform = `translateX(${translateX}%)`;

      slides.forEach((slide, i) => {
        slide.classList.toggle("cust-active", i === index);
      });

      const progressWidth = ((currentSlide + 1) / totalSlides) * 100;
      progressBar.style.width = `${progressWidth}%`;
    };

    // Previous Slide
    prevBtn?.addEventListener("click", () => {
      currentSlide = currentSlide > 0 ? currentSlide - 1 : totalSlides - 1;
      updateSlider(currentSlide);
    });

    // Next Slide
    nextBtn?.addEventListener("click", () => {
      currentSlide = (currentSlide + 1) % totalSlides;
      updateSlider(currentSlide);
    });

    // Touch Start
    slider?.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true;
      isHorizontalSwipe = false;
    });

    // Touch Move
    slider?.addEventListener("touchmove", (e) => {
      if (!isDragging) return;

      moveX = e.touches[0].clientX - startX;
      moveY = e.touches[0].clientY - startY;

      if (!isHorizontalSwipe) {
        isHorizontalSwipe = Math.abs(moveX) > Math.abs(moveY);
      }

      if (isHorizontalSwipe) {
        e.preventDefault();
        slider.style.transform = `translateX(${moveX}px)`;
      }
    }, { passive: false });

    // Touch End
    slider?.addEventListener("touchend", () => {
      isDragging = false;

      if (isHorizontalSwipe) {
        if (moveX > 50) {
          currentSlide = currentSlide > 0 ? currentSlide - 1 : totalSlides - 1;
        } else if (moveX < -50) {
          currentSlide = (currentSlide + 1) % totalSlides;
        }
        updateSlider(currentSlide);
      }
    });

    // Init
    updateSlider(0);
  }
}

customElements.define("productcard-media", ProductCardMedia);


    // Footer Mobile Dropdown
    document.querySelectorAll('.footer__block--links p.h6').forEach(function(item) {
      item.addEventListener('click', function() {
        this.closest('.footer__block--links').classList.toggle('active');
      });
    });
    // custom accordian popup
    document.querySelectorAll(".pop_button").forEach(function (button) {
        button.addEventListener("click", function () {
            let parentBlock = this.closest(".product-info__block-item");
            if (parentBlock) {
                parentBlock.querySelector(".product_accordian_poup")?.classList.remove("hidden");
                parentBlock.querySelector(".overlay_custom")?.classList.remove("hidden");
            }
        });
    });

    // Click event on .popup_close
    document.addEventListener("click", function (event) {
        if (event.target.classList.contains("popup_close")) {
            let parentPopup = event.target.closest(".product_accordian_poup");
            if (parentPopup) {
                parentPopup.classList.add("hidden");
                let overlay = parentPopup.closest(".product-info__block-item")?.querySelector(".overlay_custom");
                if (overlay) {
                    overlay.classList.add("hidden");
                }
            }
        }
    });

    // Click event on .overlay_custom
    document.addEventListener("click", function (event) {
        if (event.target.classList.contains("overlay_custom")) {
            event.target.classList.add("hidden");
            let popup = event.target.closest(".product-info__block-item")?.querySelector(".product_accordian_poup");
            if (popup) {
                popup.classList.add("hidden");
            }
        }
    });
  // Animate first image on collection 
     const productMedia = document.querySelector(".collection__main .product-list .product-card:first-child .product-card__media");
      setTimeout(function() {
        if (productMedia) {
            productMedia.classList.add("animate-slide");
        }
    }, 1000);
    setTimeout(function() {
       if (productMedia) {
            productMedia.classList.remove("animate-slide");
        }
   }, 2000);
 
    // paswdpopup
    const trigger = document.querySelector('[aria-controls="storefront-password-popup"]');
    const popup = document.querySelector('.password_form_popup');
    const overlay = document.querySelector('.overlay_custom');
    const closeBtns = document.querySelectorAll('.pop_close, .overlay_custom');

    if (trigger && popup && overlay) {
        trigger.addEventListener("click", function () {
            popup.classList.remove("hidden");
            overlay.classList.remove("hidden");
        });

        closeBtns.forEach(btn => {
            btn.addEventListener("click", function () {
                popup.classList.add("hidden");
                overlay.classList.add("hidden");
            });
        });
    }
    // Update product iomage
      function updateGallery(selectedThumbnail) {
        if (!selectedThumbnail) return;
    
        let altText = selectedThumbnail.querySelector("img")?.getAttribute("alt").trim().replace(/\s+/g, ' ');
    
        document.querySelectorAll('.product-gallery [data-media-type="image"]').forEach(galleryImage => {
            let galleryAlt = galleryImage.querySelector("img")?.getAttribute("alt").trim().replace(/\s+/g, ' ');
    
            if (galleryAlt === altText) {
                galleryImage.classList.remove("hidden");
            } else {
                galleryImage.classList.add("hidden");
            }
        });
     
        const visibleimages = document.querySelectorAll('.product-gallery__image-list .product-gallery__media');
          const visibleIndexes = [];
          
          visibleimages.forEach((image, index) => {
            if (!image.classList.contains('hidden')) {
              visibleIndexes.push(index);
            }
          });
          const buttons = document.querySelectorAll(".product-gallery carousel-navigation.page-dots button");
    

        buttons.forEach((button, index) => {
           if (visibleIndexes.includes(index)) {
                button.style.display = "block"; // Show only buttons for visible images
              } else {
                button.style.display = "none"; // Hide other buttons
              }
        });


        
    }
    let initialThumbnail = document.querySelector(".product-info__block-item :checked + .thumbnail-swatch");
    updateGallery(initialThumbnail);
    if (!initialThumbnail){
      const buttons = document.querySelectorAll(".product-gallery carousel-navigation.page-dots button");
    

        buttons.forEach((button, index) => {
           button.style.display = "block";
        });
    }
    document.addEventListener("click", function (event) {
      if (event.target.closest(".thumbnail-swatch:not(.cust-options)")) {
          let thumbnail = event.target.closest(".thumbnail-swatch");
          updateGallery(thumbnail);
      }
    });

});

class CartReservation extends HTMLElement {
  constructor() {
    super();
      this.defaultMinutes = parseInt(this.getAttribute("minutes")) || 15;
      this.startText = this.getAttribute("data-start-text") || "Your items are reserved for";
      this.endText =this.getAttribute("data-end-text") ||
        "Your items are no longer reserved, it’s possible that they get sold out";

      this.timerInterval = null;
      this.endTime = null;

      // ✅ UI Elements
      this.container = document.createElement("div");
      this.container.classList.add('reservation-wrapper');
      this.textDiv = document.createElement("div");
      this.textDiv.classList.add("reservation-text");
      this.timerDiv = document.createElement("div");
      this.timerDiv.classList.add("reservation-timer");

      this.container.append(this.textDiv, this.timerDiv);

      // ✅ Append to the light DOM so your theme CSS works
      this.appendChild(this.container);
  }

  connectedCallback() {
    document.addEventListener("cart:change", (e) => this.handleCartChange(e));
    const hasItemsOnLoad = parseInt(this.getAttribute("data-has-item")) > 0;
    this.toggleHasItemsClass(hasItemsOnLoad);
    this.restoreTimerIfNeeded(hasItemsOnLoad);
  }

  handleCartChange(event) {
    const cart = event.detail.cart;
    const hasItems = cart && cart.items && cart.items.length > 0;
    this.toggleHasItemsClass(hasItems);

    if (hasItems) {
      localStorage.removeItem("cartReservationExpired");
      if (!this.endTime) {
        this.startTimer();
      }
    } else {
      this.clearTimer(true);
    }
    document.querySelector('cart-drawer')?.setAttribute('data-cart-count', cart.items.length);
  }

  toggleHasItemsClass(hasItems) {
    if (hasItems) {
      this.classList.add("has-items");
    } else {
      this.classList.remove("has-items");
    }
  }

  startTimer() {
    if (!this.endTime) {
      this.endTime = Date.now() + this.defaultMinutes * 60 * 1000;
      localStorage.setItem("cartReservationEndTime", this.endTime);
    }
    this.updateTimerUI();
    this.startInterval();
  }

  startInterval() {
    if (this.timerInterval) clearInterval(this.timerInterval);
    this.timerInterval = setInterval(() => {
      this.updateTimerUI();
    }, 1000);
  }

  updateTimerUI() {
    const remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      this.clearTimer(false);
      return;
    }

    const minutes = Math.floor((remaining / 1000 / 60) % 60);
    const seconds = Math.floor((remaining / 1000) % 60)
      .toString()
      .padStart(2, "0");

    this.textDiv.textContent = this.startText;

    if (!this.timerDiv.isConnected) {
      this.timerDiv = document.createElement("div");
      this.timerDiv.classList.add("reservation-timer");
      this.container.appendChild(this.timerDiv);
    }
    this.timerDiv.textContent = `${minutes}:${seconds}`;
  }

  clearTimer(cartEmptied = false) {
    clearInterval(this.timerInterval);
    this.timerInterval = null;
    this.endTime = null;
    localStorage.removeItem("cartReservationEndTime");

    if (cartEmptied) {
      this.textDiv.textContent = "";
      if (this.timerDiv.isConnected) this.timerDiv.remove();
    } else {
      this.textDiv.textContent = this.endText;
      if (this.timerDiv.isConnected) this.timerDiv.remove();
      localStorage.setItem("cartReservationExpired", "true");
    }
  }

  restoreTimerIfNeeded(hasItems) {
    const storedEndTime = localStorage.getItem("cartReservationEndTime");
    const expiredFlag = localStorage.getItem("cartReservationExpired");

    if (expiredFlag === "true" && hasItems) {
      this.clearTimer(false);
      return;
    }

    if (storedEndTime) {
      this.endTime = parseInt(storedEndTime);
      if (this.endTime > Date.now() && hasItems) {
        this.startTimer();
      } else {
        this.clearTimer(!hasItems);
      }
    } else if (!storedEndTime && hasItems && expiredFlag !== "true") {
      this.startTimer();
    } else {
      this.clearTimer(true);
    }
  }
}

customElements.define("cart-reservation", CartReservation);
